module.exports = __webpack_public_path__ + "static/media/chat-help.89fbd722.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chat-help.svg
// module id = 1617
// module chunks = 103